/**
 * html関連のutilクラス。
 */
export class HtmlUtils {

	/**
	 * 指定のurlからファイルをダウンロードする。
	 * 
	 * @param url 
	 */
	static download(url: string): void {
		const aElement = document.createElement('a');
		document.body.appendChild(aElement);
		aElement.href = url;
		aElement.target = '_blank';
		aElement.click();
		aElement.remove();
	}
}